import React from 'react';
import {
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Add as AddIcon, LocationOn as LocationIcon } from '@mui/icons-material';

interface EmptyStateProps {
  projectName: string;
  onAddFirst: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = React.memo(({
  projectName,
  onAddFirst,
}) => {
  return (
    <Paper 
      sx={{ 
        p: 6, 
        textAlign: 'center',
        backgroundColor: 'background.default',
        border: '2px dashed',
        borderColor: 'divider',
      }}
    >
      <LocationIcon 
        sx={{ 
          fontSize: 72, 
          color: 'text.secondary', 
          mb: 2,
          opacity: 0.5,
        }} 
      />
      <Typography variant="h5" color="text.secondary" gutterBottom fontWeight="medium">
        No Locations Found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>
        Start building routes for <strong>{projectName}</strong> by adding your first location. 
        Locations can be warehouses, customer sites, or delivery points.
      </Typography>      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onAddFirst}
        size="large"
        sx={{ 
          background: 'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)',
          },
          px: 4,
          py: 1.5,
        }}
      >
        Add First Location
      </Button>
    </Paper>
  );
});

EmptyState.displayName = 'EmptyState';
